export const doRedirect = (redirectUrl, route = '#/customers') => {
  document.location = `https://${
    document.location.host
  }/${document.location.pathname.replace(/^\//, '')}${
    redirectUrl ? decodeURI(redirectUrl) : route
  }`;
};
